module.exports = __webpack_public_path__ + "media/images/webpage/pages/about/section-3-09df2b1cc66a962ba5ae5da2b31561eb.webp";